<form #searchForm="ngForm">
  <div class="multiinput-all-groups">
    <ng-container *ngFor="let multiInputConfig of multiInputConfiguration?.multiInputConfigurations">
      <div *ngIf="multiInputConfig.header" class="editableItem multiinput-group-header">
        {{ multiInputConfig.header | translate }}
      </div>
      <div *ngFor="let item of multiInputConfig.configurableItems; let last = last" class="editableItem avano-scrollbars" [class.is--last]="last">
        <span *ngIf="item.header">{{ item.header | translate }}</span>
        <div [ngSwitch]="item.type">
          <div *ngSwitchCase="editableItemType.AUTOCOMPLETE">
            <p-autoComplete
              class="autoComplete"
              [(ngModel)]="item.content"
              [suggestions]="$any(item).suggestionHeaders"
              (onSelect)="$any(item).select($event)"
              (completeMethod)="$any(item).search($event)"
              appendTo="body"
              [name]="item.header"
            ></p-autoComplete>
          </div>
          <div *ngSwitchCase="editableItemType.INPUT">
            <input
              class="input"
              type="text"
              [(ngModel)]="item.content"
              [name]="item.header"
              (keyup.enter)="tryCallActionButtonAction()"
              avanoInputText
              ngDefaultControl
            />
          </div>
          <div *ngSwitchCase="editableItemType.MULTISELECT">
            <p-multiSelect
              [(ngModel)]="item.selection"
              [options]="item.suggestions"
              [placeholder]=" "
              [optionLabel]="item.field"
              [maxSelectedLabels]="10"
              class="avano-combobox-style"
              [panelStyleClass]="'avano-combobox-overlay avano-scrollbars'"
              [styleClass]="'avano-multiselect-scrollbar'"
              [appendTo]="'body'"
              [emptyFilterMessage]="translationKeys.commonTranslationKey.filter.noResults | translate"
              [resetFilterOnHide]="true"
              [name]="item.header"
              #multiSelect
            >
              <ng-template pTemplate="selectedItems">
                <div *ngFor="let element of item.selection" class="avano-chips">
                  <div class="avano-chips-label" scipSpacesAsIs>
                    <ng-container *ngIf="item.suggestionsTranslate; else noItemTranslations">
                      {{ element.name | translate }}
                    </ng-container>
                    <ng-template #noItemTranslations>
                      {{ element.name }}
                    </ng-template>
                  </div>
                  <span class="icon-content-cancel" (click)="multiSelect.removeChip(element, $event)"></span>
                </div>
              </ng-template>
              <ng-template let-singleSuggestion pTemplate="item">
                <ng-container *ngIf="item.suggestionsTranslate; else noSuggestionTranslation">
                  {{ singleSuggestion.name | translate }}
                </ng-container>
                <ng-template #noSuggestionTranslation>
                  <span scipSpacesAsIs>{{ singleSuggestion.name }}</span>
                </ng-template>
              </ng-template>
            </p-multiSelect>
          </div>
          <div *ngSwitchCase="editableItemType.RADIOBUTTONS">
            <div *ngFor="let radiobutton of item.inputs" class="radioButtonGroup">
              <avano-radiobutton [name]="radiobutton.label" [value]="radiobutton" [(ngModel)]="item.content" (click)="itemSelectionChanged(item)">
                {{ radiobutton.label | translate }}
              </avano-radiobutton>
            </div>
          </div>
          <div *ngSwitchCase="editableItemType.CHECKBOXES">
            <div *ngFor="let checkbox of item.inputs" class="checkBoxGroup">
              <avano-checkbox
                [value]="checkbox"
                [(ngModel)]="checkbox.selectedValue"
                [binary]="true"
                [disabled]="checkbox.disabled"
                (onChange)="itemSelectionChanged(item)"
                [name]="checkbox.label"
              >
                {{ checkbox.label | translate }}
              </avano-checkbox>
            </div>
          </div>
          <div *ngSwitchCase="editableItemType.DATE_FROM_TO" class="date-picker-style">
            <p-calendar
              [(ngModel)]="item.selection[0]"
              [placeholder]="item.placeholderFrom | translate"
              [showIcon]="true"
              [maxDate]="item.selection[1] || todayDate"
              appendTo="body"
              class="scip-calendar-input"
              [name]="item.header + '-from'"
            ></p-calendar>
            <span class="date-picker-between">-</span>
            <p-calendar
              [(ngModel)]="item.selection[1]"
              [placeholder]="item.placeholderTo | translate"
              [showIcon]="true"
              [minDate]="item.selection[0]"
              [maxDate]="todayDate"
              appendTo="body"
              class="scip-calendar-input"
              [name]="item.header + '-to'"
            ></p-calendar>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</form>

<!-- Clear/Search-buttons always at the bottom -->
<div class="button-grid">
  <div class="clearButton">
    <button
      *ngIf="multiInputConfiguration?.showClearButton"
      type="button"
      avanoButton
      label="{{ translationKeys.multiInputComponent.html.clearButtonLabel | translate }}"
      icon="icon-content-edit"
      (click)="clear()"
      [disabled]="!isDirty"
    ></button>
  </div>
  <div class="actionButton">
    <!-- For some reasons, the button is not updated if the icon is initially not set (due to asynchronous stuff) -->
    <button
      type="button"
      avanoButton
      [callToAction]="true"
      [label]="multiInputConfiguration?.actionButtonLabel | translate"
      [icon]="multiInputConfiguration?.actionButtonIcon || 'icon-content-search'"
      (click)="tryCallActionButtonAction()"
    ></button>
  </div>
  <!-- placeholder für dritten Button/Tag, der in Mockups angedeutet wurde -->
  <div class="hrefText">
    <div *ngIf="multiInputConfiguration?.showHref">
      <span [ngClass]="multiInputConfiguration?.hrefIcon" href="http://google.com">
        {{ multiInputConfiguration?.hrefText }}
      </span>
    </div>
  </div>
</div>
